var _path, _path2, _path3, _path4;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUnpinV2 = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 10.6666L2 14",
    stroke: "#59697D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L14 14",
    stroke: "#59697D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33293 6.33337H3.27574C2.6818 6.33337 2.38435 7.05147 2.80433 7.47144L8.51986 13.187C8.94101 13.6081 9.66098 13.3077 9.65792 12.7121L9.64221 9.65784",
    stroke: "#59697D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3328 8.33329C11.9102 7.92405 12.9522 7.2359 13.6435 6.78317C13.9984 6.55073 14.0506 6.05055 13.7507 5.75056L10.2007 2.20055C9.91713 1.91703 9.44927 1.94613 9.20307 2.2626L7.33276 4.66663",
    stroke: "#59697D",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnpinV2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/unpin-v2.70bb0a8b.svg";
export { ForwardRef as ReactComponent };